import { List, Spin } from 'antd';
import React from 'react';
import successIcon from '../../assets/images/success.png'

//字节单位转换函数
var byteConvert = function (bytes) {
    if (isNaN(bytes)) {
        return '';
    }
    var symbols = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var exp = Math.floor(Math.log(bytes) / Math.log(2));
    if (exp < 1) {
        exp = 0;
    }
    var i = Math.floor(exp / 10);
    bytes = bytes / Math.pow(2, 10 * i);

    if (bytes.toString().length > bytes.toFixed(2).toString().length) {
        bytes = bytes.toFixed(2);
    }
    return bytes + ' ' + symbols[i];
};


const UploadList = ({ data, ...props }) => {
    return (
        <section style={{ overflow: 'scroll', height: 240, lineHeight: '80px' }}>
            {props.status === 'finish' && (
                <section style={{ height: 80, background: '#69c0ff' }}>
                    <img
                        style={{ marginLeft: 20, width: 30, position: 'relative', top: -4 }}
                        src={successIcon}
                        alt=""
                    />
                    <span style={{ fontSize: 20, color: '#fff', marginLeft: 10 }}>上传完成</span>
                    <span
                        style={{
                            fontSize: 14,
                            color: '#fff',
                            marginLeft: 60,
                            position: 'relative',
                            top: -6
                        }}
                    >
                        成功{props.successCount}
                    </span>
                    <span
                        style={{
                            fontSize: 14,
                            color: '#fff',
                            marginLeft: 10,
                            position: 'relative',
                            top: -6
                        }}
                    >
                        失败{data.length}
                    </span>
                </section>
            )}
            {props.status === 'finish' && data.length === 0 && (
                <div style={{ textAlign: 'center' }}>均上传成功</div>
            )}

            {data.length !== 0 && (
                <List
                    size="small"
                    dataSource={data}
                    renderItem={(item) => (
                        <List.Item>
                            <div>
                                <p style={{ maxWidth: 200 }} className="exceeding">
                                    {item.file.name}
                                </p>
                                <p>{byteConvert(item.file.size)}</p>
                            </div>

                            <div>
                               
                                {(item.asyncStatus === 'uploading' || item.asyncStatus === '') ? <Spin /> : null}

                                {item.asyncStatus === 'success' ? (
                                    <i
                                        style={{ fontSize: 24, color: '#ccc' }}
                                        className="iconfont icon-check-outlined"
                                    ></i>
                                ) : null}
                                {['error', 'fail'].includes(item.asyncStatus) ? (
                                    <i
                                        style={{ fontSize: 24, color: 'red' }}
                                        className="iconfont icon-close-outlined"
                                    ></i>
                                ) : null}
                            </div>
                        </List.Item>
                    )}
                />
            )}
        </section>
    );
};
export default UploadList;
